import Vue from 'vue'
import axios from "axios";

let config = {
  baseURL: (process.env.VUE_APP_BASE_URL || '/api/') + 'chat/',
  responseType: 'json',
  headers: {},
  // SPA is served same-origin under /app/ - a relative path works and is
  // turned into wss://<origin>/ws/chat/ by storage.js connectWebSocket()
  webSocketUrl: process.env.VUE_APP_CHAT_WS_URL || '/ws/chat/',
};

const _axios = axios.create(config);
Vue.prototype.$chat = _axios;

_axios.interceptors.request.use(
  function(config) {
    let token = localStorage.getItem('speaker_tool_token')
    if (token)
      config.headers.Authorization = `Token ${token}`;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// Redirect to login on 401 (invalid/expired token)
let _redirecting = false
_axios.interceptors.response.use(
  function(response) { return response },
  function(error) {
    if (error.response && error.response.status === 401 && !_redirecting) {
      _redirecting = true
      localStorage.removeItem('speaker_tool_token')
      localStorage.removeItem('speaker_tool_user')
      localStorage.removeItem('user_uuid')
      localStorage.removeItem('direct-channels')
      localStorage.removeItem('contact-ids')
      window.location.href = '/login?next=' + encodeURIComponent(window.location.pathname)
    }
    return Promise.reject(error)
  }
);
